import React, { useEffect, useState } from 'react';
import { TextField, FormHelperText } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import { FieldExtensionComponentProps } from '@backstage/plugin-scaffolder-react';
import { catalogApiRef } from '@backstage/plugin-catalog-react';
import { useApi } from '@backstage/core-plugin-api';

export const RepositoryNameDropdown = (
  props: FieldExtensionComponentProps<string>,
) => {
  const { onChange, required, rawErrors, formData, uiSchema, schema } = props;

  const catalogApi = useApi(catalogApiRef);
  const [repositories, setRepositories] = useState<string[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchRepositories = async () => {
      try {
        setLoading(true);
        // Fetch all system entities
        const entities = await catalogApi.getEntities({
          filter: {
            kind: 'System',
          },
        });

        // Extract unique namespace values (repository names)
        const namespaces = Array.from(
          new Set(
            entities.items
              .map(entity => entity.metadata.namespace)
              .filter((ns): ns is string => !!ns && ns !== 'default'),
          ),
        ).sort();

        setRepositories(namespaces);
      } catch (error) {
        console.error('Error fetching repositories:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchRepositories();
  }, [catalogApi]);

  const handleChange = (
    _event: React.ChangeEvent<{}>,
    value: string | null,
  ) => {
    onChange(value || '');
  };

  return (
    <>
      <Autocomplete
        options={repositories}
        value={formData || null}
        onChange={handleChange}
        loading={loading}
        disabled={loading}
        renderInput={params => (
          <TextField
            {...params}
            label={schema.title || 'Repository Name'}
            required={required}
            error={rawErrors && rawErrors.length > 0}
            helperText={
              loading
                ? 'Loading repositories...'
                : uiSchema?.['ui:help'] || schema.description
            }
            margin="normal"
            fullWidth
          />
        )}
      />
      {rawErrors && rawErrors.length > 0 && (
        <FormHelperText error>{rawErrors.join(', ')}</FormHelperText>
      )}
    </>
  );
};
